export const supplierValue =
[
  {
    field: 'Mechanical',
    contact: [
      { name: '', email: 'spareparts@sms-group.com', phone: '' },
    ]
  },
  {
    field: 'Electrical',
    contact: [
      { name: 'Rick', email: 'abc@gmail.com', phone: '123-456-7890' },
      { name: 'Scott', email: 'abc@gmail.com', phone: '123-456-7890' },
    ]
  },
]
